export function format(number) {
    return typeof number === 'number' ? number?.toLocaleString('fr') : number
}

export function integersOnly(value) {
    return value.replace(/[^0-9]/gim, '')
}

export function normalizePhone(phone) {
    if (phone.length === 9) {
        return phone.replace(/(\d{2})(\d{3})(\d{2})(\d{2})/, '($1) $2-$3-$4')
    }
    return phone
}
